<h1 mat-dialog-title>Logout</h1>

<div mat-dialog-content>
    Are you sure you want to log out?
</div>

<br>

<div data-testid="logout-dialog-float-right" class="float-right">
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">Cancel</button>
        <!--class="btn btn-danger"-->
        <button data-testid="logout-dialog-button" mat-raised-button color="warn" (click)="dialogRef.close(data.logoutMonitorValue)" cdkFocusInitial>Log out</button>
    </div>
</div>